import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import {Accordion, AccordionItem} from "@nextui-org/accordion";
import {Tabs, Tab, Card, CardBody, CardHeader, Skeleton, Button} from "@nextui-org/react";
import au1 from '../assets/au1.jpg'
import {Breadcrumbs, BreadcrumbItem} from "@nextui-org/react";
import { FaEye, FaHome } from "react-icons/fa";
import home from '../assets/home.jpg' 
import { FiTarget } from 'react-icons/fi';
import story from '../assets/story.jpg'

const AboutScreen = () => {
  const dispatch = useDispatch()
    const history = useNavigate()
    const location = useLocation()

    const [selected, setSelected] = React.useState("photos");


    useEffect(() => {
      window.scroll(0,0);
    }, [location]);
  return (
    <div className='h-fit w-full flex flex-col gap-12 pb-12'>
      <section className='h-fit w-full relative bg-black'>
        <img src={au1} alt='' className='h-[300px] w-full object-cover relative z-0 opacity-50' />
        <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-2'>
          <p className='text-2xl md:text-4xl text-white font-bold'>About us</p>
          <div className="flex flex-col flex-wrap gap-4">
            
              <Breadcrumbs 
                classNames={{
                  list: "bg-black  bg-opacity-50 text-white p-4",
                }}
                itemClasses={{
                  item: "text-white data-[current=true]:text-white",
                  separator: "text-white/40",
                }}
              key={'i'} variant={'solid'} >
                <BreadcrumbItem className='text-white'>
                  <FaHome className='text-red-600 text-xl' />
                  <p className='pl-1'>Home</p>
                </BreadcrumbItem>
                <BreadcrumbItem className='text-white'>
                  <div className='border-[1px] border-red-600 p-[3px] rounded-full'>

                  </div>
                  <p className='pl-1'>About</p>
                </BreadcrumbItem>
              </Breadcrumbs>
            
          </div>
        </div>
      </section>

      <section className='h-fit w-full relative overflow-hidden '>
        <div className='h-fit w-full max-w-[1024px] mx-auto px-[25px] sm:px-[50px] md:px-[75px] lg:px-[25px] flex flex-col gap-12'>
          <div className='h-fit w-full justify-center gap-2 flex flex-col md:flex-row items-center'>
              <div className='h-[300px] lg:h-[400px] w-full md:w-[300px] lg:w-[400px]'>
                <div className='h-[300px] lg:h-[400px] w-full min-w-[300px] lg:w-[400px] md:w-[300px] lg:min-w-[400px]'>
                  <img src={home} alt='' className='h-full w-full object-contain'/>
                </div>
              </div>
              <div className='h-fit w-full flex flex-col gap-2'>
                <p className='text-2xl font-bold'>Welcome to BritishQual </p>
                <div className=' flex gap-2'>
                  <div className='h-1 w-4 rounded-full bg-red-600'></div>
                  <div className='h-1 w-6 rounded-full bg-red-600'></div>
                </div>
                <p className='text-sm uppercase opacity-25'>
                  At British Graduate Campus, we take pride in being a premier institution 
                  dedicated to shaping future leaders through world-class education. We offer 
                  both online and onsite programs, including Certificate Courses, Diploma and 
                  Higher Diploma Programs, Degree Programs, Masters, and Doctorate 
                  Programs. In addition, our Study Abroad Consultation Services empower 
                  students to achieve their academic dreams on a global scale. 
                </p>
                <p className='text-sm uppercase opacity-25'>
                  Our campus thrives on a dynamic learning environment that combines 
                  academic excellence, cutting-edge teaching methods, and a passion for 
                  nurturing talent. We are committed to providing students with international 
                  standards of education, unparalleled global exposure, and access to a diverse 
                  and influential alumni network.  
                </p>
                <Button className='h-[50px] w-fit border-black border-2 bg-transparent font-bold text-lg text-black mt-4' radius='none'>
                  Register
                </Button>
              </div>
          </div>
          <p className='text-center'>Step into British Graduate Campus and begin a transformative journey toward a brighter, more successful 
        future. Your aspirations, our commitment! </p>
        </div>
      </section>

      <section className='h-fit w-full relative overflow-hidden py-16'>
        <div className='h-fit w-full max-w-[1024px] mx-auto px-[25px] sm:px-[50px] md:px-[75px] lg:px-[25px] justify-center flex flex-col md:flex-row items-start gap-6'>
              <div className='py-8 px-12 cursor-pointer shadow-xl hover:shadow-2xl duration-300 flex flex-col gap-4 '>
                  <FiTarget className='text-8xl text-blue-400'/>
                  <p className='text-2xl font-bold'>Our Vission</p>
                  <div className='flex flex-col gap-2'>
                    <p className='text-sm opacity-75'>To redefine the future of education by creating a global hub of excellence, where innovation, inclusivity, and 
                    transformative learning empower individuals to lead, inspire, and make a lasting impact on the world. </p>
                  </div>
              </div>
              <div className='py-8 px-12 cursor-pointer shadow-xl hover:shadow-2xl duration-300 flex flex-col gap-4 '>
                  <FaEye className='text-8xl text-blue-400'/>
                  <p className='text-2xl font-bold'>Our mission</p>
                  <div className='flex flex-col gap-2'>
                    <p className='text-sm opacity-75'>At British Graduate Campus, we are committed to delivering world-class education and guidance 
                    through innovative teaching, personalized support, and diverse opportunities. We strive to inspire lifelong 
                    learning, nurture critical thinking, and foster a global perspective to shape the leaders of tomorrow.</p>
                  </div>
              </div>
        </div>
      </section>

      <section className='h-fit w-full relative overflow-hidden py-16'>
        <div className='h-fit w-full max-w-[800px] mx-auto px-[25px] sm:px-[50px] md:px-[75px] lg:px-[25px] justify-center flex flex-col gap-6'>
          <p className='text-4xl font-bold text-center'>Core Principles of British Graduate Campus 
          </p>

          <Accordion defaultExpandedKeys={["1","2","3","4","5"]} isCompact>
            <AccordionItem className='text-black/50 py-4' key="1" aria-label="Accordion 1" title={
              <p className='text-xl font-bold'>Academic Excellence </p>
            }>
              We are committed to delivering the highest standards of education, ensuring that our students gain the 
              knowledge, skills, and qualifications they need to excel in their chosen fields. 
            </AccordionItem>

            <AccordionItem className='text-black/50 py-4' key="2" aria-label="Accordion 2" title={
              <p className='text-xl font-bold'>Innovative Learning </p>
            }>
              Our programs integrate cutting-edge teaching methods and state-of-the-art technology, providing a dynamic 
and engaging learning experience that meets modern academic and professional demands. 
 
            </AccordionItem>

            <AccordionItem className='text-black/50 py-4' key="3" aria-label="Accordion 3" title={<p className='text-xl font-bold'> Global Exposure</p>}>
            As part of the European Nation Campus network, we offer our students access to international education 
            standards, diverse cultural experiences, and opportunities to connect with a global alumni community.  
            </AccordionItem>

            <AccordionItem className='text-black/50 py-4' key="4" aria-label="Accordion 4" title={
              <p className='text-xl font-bold'> Student-Centric Approach</p>
            }>
              At the heart of our mission is the success and well-being of our students. We provide personalized support, 
              mentorship, and resources to help them achieve their academic and career goals. 
            </AccordionItem>

            <AccordionItem className='text-black/50 py-4' key="5" aria-label="Accordion 5" title={
              <p className='text-xl font-bold'>Commitment to Lifelong Learning</p>
            }>
              We believe education is a continuous journey. Through our diverse range of programs and study abroad 
              consultancy, we empower individuals to keep learning, growing, and adapting to an ever-evolving world.
            </AccordionItem>
          </Accordion>


        </div>
      </section>

      <section className='h-fit w-full relative overflow-hidden py-16  bg-blue-950 text-white'>
        <div className='h-fit w-full max-w-[1024px] mx-auto px-[25px] sm:px-[50px] md:px-[75px] lg:px-[25px] justify-center gap-16 flex flex-col-reverse md:flex-row-reverse items-center '>
              <div className='h-[300px] lg:h-[400px] w-full md:w-[300px] lg:w-[400px] '>
                <div className='h-[300px] lg:h-[400px] w-full min-w-[300px] lg:w-[400px] md:w-[300px] lg:min-w-[400px] '>
                  <img src={story} alt='' className='h-full w-full object-cover'/>
                </div>
              </div>
              <div className='h-fit w-full flex flex-col gap-4'>
                <p className='text-3xl font-bold'>Our Story</p>
                <div className=' flex gap-2'>
                  <div className='h-1 w-4 rounded-full bg-red-600'></div>
                  <div className='h-1 w-6 rounded-full bg-red-600'></div>
                </div>
                <p className='text-sm opacity-50'>British Graduate Campus was established with a mission to provide world-class education that transforms 
                lives and builds a brighter future. With a commitment to excellence and innovation, we serve as a gateway 
                for aspiring learners and professionals to achieve their goals and unlock their true potential.</p>
                <p className='text-sm opacity-50'>Our institution offers a wide array of programs, including online and onsite Certificate Courses, Diplomas, 
                Higher Diplomas, Degree Programs, Masters, and Doctorate Programs. We also specialize in Study Abroad 
                Consultation Services, ensuring that students have access to global opportunities and resources to succeed in 
                their chosen paths. </p>
                  <p className='text-sm opacity-50'>At British Graduate Campus, we embrace the principles of accessibility, affordability, and flexibility, making 
                high-quality education available to learners from all walks of life. Our vibrant learning environment combines 
                academic rigor with real-world applications, empowering students to think critically, act decisively, and lead 
                confidently. </p>
                <p className='text-sm opacity-50'>Through innovative teaching methods, expert faculty, and state-of-the-art resources, we create a nurturing 
                space where students can thrive, grow, and achieve their aspirations. Whether you are looking to advance 
                your career, broaden your horizons, or make a meaningful impact, British Graduate Campus is here to guide 
                you every step of the way. </p>
                <p className='text-sm opacity-50'>Join us on this transformative journey and take the first step toward realizing your dreams. Together, we 
                build a future driven by knowledge, innovation, and excellence.</p>
              </div>
        </div>
      </section>

      <section className='h-fit w-full relative overflow-hidden py-16'>
        <div className='h-fit w-full max-w-[800px] mx-auto px-[25px] sm:px-[50px] md:px-[75px] lg:px-[25px] justify-center flex flex-col gap-6'>
          <p className='text-4xl font-bold text-center'>Learning Model</p>

          <Accordion defaultExpandedKeys={["1","2","3","4","5"]} isCompact>
            <AccordionItem className='text-black/50 py-4' key="1" aria-label="Accordion 1" title={
              <p className='text-xl font-bold'>1. Blended Learning Model </p>
            }>
              A perfect mix of online and onsite learning. Students attend physical classes for in-depth discussions while 
accessing recorded lectures, assignments, and resources online. This model provides flexibility and ensures 
quality learning for students balancing education with work or other commitments. 
            </AccordionItem>

            <AccordionItem className='text-black/50 py-4' key="2" aria-label="Accordion 2" title={
              <p className='text-xl font-bold'>2. Competency-Based Learning 
</p>
            }>
              Focuses on mastering specific skills or knowledge required for career success. This model allows students to 
progress at their own pace by demonstrating their expertise, making it ideal for certificate and diploma 
programs. 
            </AccordionItem>

            <AccordionItem className='text-black/50 py-4' key="3" aria-label="Accordion 3" title={<p className='text-xl font-bold'>3. Flipped Classroom Model</p>}>
            Reverses traditional learning by letting students study materials independently before attending interactive 
onsite sessions. This encourages active participation and deeper understanding, making it ideal for advanced 
programs like degrees and masters.  
            </AccordionItem>

            <AccordionItem className='text-black/50 py-4' key="4" aria-label="Accordion 4" title={
              <p className='text-xl font-bold'>4. Project-Based Learning (PBL) </p>
            }>
              This hands-on approach engages students in real-world projects to apply what they’ve learned. Students 
develop critical thinking and problem-solving skills, making it a great choice for diploma and higher diploma 
programs.   
            </AccordionItem>

            <AccordionItem className='text-black/50 py-4' key="5" aria-label="Accordion 5" title={
              <p className='text-xl font-bold'>5. Study Abroad-Integrated Learning </p>
            }>
             Prepares students for international education by offering cultural training, academic workshops, and 
             language support. This model ensures students are equipped to succeed in global academic settings. 
            </AccordionItem>


            <AccordionItem className='text-black/50 py-4' key="5" aria-label="Accordion 5" title={
              <p className='text-xl font-bold'>6. Collaborative Learning </p>
            }>
             Encourages teamwork and peer interaction through group discussions, projects, and activities. This approach 
             nurtures communication and leadership skills, making it ideal for degree and master's programs. 
            </AccordionItem>
            
            <AccordionItem className='text-black/50 py-4' key="5" aria-label="Accordion 5" title={
              <p className='text-xl font-bold'>7. Experiential Learning</p>
            }>
            Provides hands-on experience through internships, simulations, or live projects. This model bridges the gap 
            between theory and practice, preparing students for real-world challenges in their chosen fields.
            </AccordionItem>
            <AccordionItem className='text-black/50 py-4' key="5" aria-label="Accordion 5" title={
              <p className='text-xl font-bold'>8. Self-Directed Learning </p>
            }>
            Empowers students to take charge of their education by allowing them to learn at their own pace. This 
            flexible model is ideal for online programs and working professionals pursuing advanced degrees.
            </AccordionItem>
            <AccordionItem className='text-black/50 py-4' key="5" aria-label="Accordion 5" title={
              <p className='text-xl font-bold'>9. Gamification in Learning </p>
            }>
            Makes education engaging and interactive by incorporating games, challenges, and rewards into the learning 
process. This model motivates students and is particularly effective for foundational courses and younger 
learners. 
            </AccordionItem>
            <AccordionItem className='text-black/50 py-4' key="5" aria-label="Accordion 5" title={
              <p className='text-xl font-bold'>10. Adaptive Learning Models</p>
            }>
           Uses technology to personalize the learning experience based on each student’s strengths and needs. This 
           ensures every student gets the support they need to excel, especially in online and preparatory courses.
            </AccordionItem>
            
          </Accordion>


        </div>
      </section>

    </div>
  )
}

export default AboutScreen